import React from 'react'

class PasswordResetWasSent extends React.Component {
  render () {
    return (
        <h3 style={{ color: 'blue' }}>Please check your email to follow a link to change the password</h3>
    )
  }
}
export default PasswordResetWasSent;